export const brandSwatches = {
  neutral: {
    "neutral-0": "#ffffff",
    "neutral-100": "#fff8ed",
    "neutral-200": "#f0ece4",
    "neutral-300": "#e8e4dc",
    "neutral-400": "#e5e0d5",
  },
  sand: {
    "sand-100": "#fff2de",
    "sand-200": "#f5e8d3",
    "sand-300": "#f0dfc3",
    "sand-400": "#f1d4ac",
  },
  orange: {
    "orange-100": "#ff9b54",
    "orange-200": "#e37f3a",
  },
  teal: {
    "teal-100": "#e0e4dc",
    "teal-300": "#05867e",
    "teal-400": "#00544e",
    "teal-500": "#003b37",
  },
  grey: {
    "grey-100": "#fcfbf5",
    "grey-200": "#f0eee9",
    "grey-300": "#e5e4df",
    "grey-400": "#6b6967",
    "grey-500": "#575753",
    "grey-600": "#3d3d3a",
  },
  red: {
    "red-100": "#fbe8e4",
    "red-500": "#b42318",
  },
  green: {
    "green-100": "#e4efe2",
    "green-500": "#2f6b3c",
  },
  amber: {
    "amber-100": "#fbefd6",
    "amber-500": "#8a5d14",
  },
} as const;

const { neutral, orange, teal, grey, red, green, amber } = brandSwatches;

export const brandColorTokens = {
  background: {
    primary: neutral["neutral-100"],
    secondary: neutral["neutral-200"],
    card: neutral["neutral-0"],
    tertiary: neutral["neutral-400"],
    quaternary: teal["teal-100"],
    actionPrimary: orange["orange-100"],
    actionPrimaryHover: orange["orange-200"],
    actionSecondary: teal["teal-400"],
    actionSecondaryHover: teal["teal-500"],
    actionTertiary: neutral["neutral-100"],
    actionTertiaryDark: neutral["neutral-300"],
    input: grey["grey-100"],
    inverted: teal["teal-500"],
  },
  text: {
    display: teal["teal-500"],
    displayInverted: grey["grey-100"],
    body: grey["grey-500"],
    bodySubtle: grey["grey-400"],
    bodyInverted: grey["grey-100"],
    actionPrimary: grey["grey-600"],
    actionSecondary: grey["grey-100"],
    actionTertiary: grey["grey-600"],
    linkHover: orange["orange-200"],
  },
  icon: {
    default: orange["orange-100"],
    subtle: grey["grey-500"],
  },
  status: {
    error: red["red-500"],
    errorBackground: red["red-100"],
    success: green["green-500"],
    successBackground: green["green-100"],
    warning: amber["amber-500"],
    warningBackground: amber["amber-100"],
    info: teal["teal-400"],
    infoBackground: teal["teal-100"],
  },
  line: {
    default: "rgb(61 61 58 / 10%)",
    light: "rgb(252 251 245 / 20%)",
    input: grey["grey-400"],
  },
} as const;
